import { render, staticRenderFns } from "./TrimmingImageEditGPX.vue?vue&type=template&id=28de78d4&scoped=true&"
import script from "./TrimmingImageEditGPX.vue?vue&type=script&lang=js&"
export * from "./TrimmingImageEditGPX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28de78d4",
  null
  
)

export default component.exports